import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VendorService {
  vendorHost = environment.config.vendorUrl;
  static = environment.config.vendorStaticUrl;

  companyId;

  constructor(private http: HttpClient) { }

  uploadPhoto(data) {
    return this.http.post<any>(this.vendorHost + 'upload', data);
  }

  vendorSignUp(data) {
    return this.http.post<any>(this.vendorHost + 'auth/register', data);
  }
  vendorLogin(data) {
    return this.http.post<any>(this.vendorHost + 'auth/login', data);
  }
  vendorVerify(data) {
    return this.http.post<any>(this.vendorHost + 'auth/verify', data);
  }
  vendorApplicantDetail(data) {
    return this.http.post<any>(this.vendorHost + 'company/applicant/', data);
  }
  updateComapanyDetails(id, data) {
    return this.http.put<any>(this.vendorHost + 'company/applicant/' + id, data);
  }
  getApplicantDetail(id) {
    return this.http.get<any>(this.vendorHost + 'company/applicant/' + id);
  }
  getServiceList() {
    return this.http.get<any>(this.vendorHost + 'service/');
  }
  saveService(data) {
    return this.http.post<any>(this.vendorHost + 'company/service/', data);
  }
  getServiceDetail(companyId) {
    return this.http.get<any>(this.vendorHost + 'company/service/' + companyId);
  }
  updateService(companyId, data) {
    return this.http.put<any>(this.vendorHost + 'company/service/' + companyId, data);
  }
  removeStateService(companyId, queryData) {
    return this.http.delete<any>(this.vendorHost + 'company/service/' + companyId, { params: queryData });
  }
  getProjectList(companyId, queryData) {
    return this.http.get<any>(this.vendorHost + 'company/project/' + companyId, { params: queryData });
  }
  saveProject(data) {
    return this.http.post<any>(this.vendorHost + 'company/project/save', data);
  }
  updateProject(projectId, data) {
    return this.http.put<any>(this.vendorHost + 'company/project/' + projectId, data);
  }

  getProjectDetail(id) {
    return this.http.get<any>(this.vendorHost + 'company/project/details/' + id);
  }
  getProjectExperienceList(queryData) {
    return this.http.get<any>(this.vendorHost + 'ulb/project/', { params: queryData });
  }
  getProjectExperienceDetail(id) {
    return this.http.get<any>(this.vendorHost + 'company/project/details/' + id);
  }
  ulbFeedback(id, data) {
    return this.http.put<any>(this.vendorHost + 'ulb/feedback/' + id, data);
  }
  getVendorList(queryData) {
    return this.http.get<any>(this.vendorHost + 'mahua/', { params: queryData });
  }
  getVendorDetail(id) {
    return this.http.get<any>(this.vendorHost + 'mahua/vendor/' + id);
  }
  saveFinance(data) {
    return this.http.post<any>(this.vendorHost + 'company/finance', data);
  }
  getFinanceDetail(id) {
    return this.http.get<any>(this.vendorHost + 'company/finance/' + id);
  }
  updateFinanceDetail(id, data) {
    return this.http.put<any>(this.vendorHost + 'company/finance/' + id, data);
  }
  removeFinance(id) {
    return this.http.delete<any>(this.vendorHost + 'company/finance/legalInfo/' + id);
  }
  removelegalInfo(id) {
    return this.http.delete<any>(this.vendorHost + 'company/finance/legalInfo/' + id);
  }
  getCommunicationList() {
    return this.http.get<any>(this.vendorHost + 'feedback');
  }
  getMessageDetail(id) {
    return this.http.get<any>(this.vendorHost + 'message/' + id);
  }
  vendorDashboard(companyId) {
    return this.http.get<any>(this.vendorHost + 'dashboard/' + companyId);
  }
  ulbDashboard() {
    return this.http.get<any>(this.vendorHost + 'ulb/dashboard');
  }
  mohuaDashboard() {
    return this.http.get<any>(this.vendorHost + 'mahua/');
  }
}
